import { render, staticRenderFns } from "./ConventionSectionsTable.vue?vue&type=template&id=6bb511c0&scoped=true"
import script from "./ConventionSectionsTable.vue?vue&type=script&lang=js"
export * from "./ConventionSectionsTable.vue?vue&type=script&lang=js"
import style0 from "./ConventionSectionsTable.vue?vue&type=style&index=0&id=6bb511c0&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb511c0",
  null
  
)

export default component.exports